export default __webpack_public_path__ + "static/neil-bitmoji-9b2e0b698501c184bf84de131df44467.png";